module.exports = __webpack_public_path__ + "static/media/logo-hi-res.2b2617a0.png";